import Cookies from 'js-cookie';

export const getCookies = () => {
    return Cookies.get('cookie') || sessionStorage.getItem('cookie');
};

export const removeCookies = () => {
    return Cookies.remove('cookie') || sessionStorage.removeItem('cookie');
};
